(function () {
  var scriptName = 'pdp-discount-price.js';

  window.Eurus = window.Eurus || { loadedScript: [] };
  window.Eurus.loadedScript = window.Eurus.loadedScript || [];

  if (window.Eurus.loadedScript.includes(scriptName)) {
    return;
  }

  window.Eurus.loadedScript.push(scriptName);

  var apiVersion = '2025-07';
  var sectionState = {};
  var responseCache = {};
  var clientCache = {};

  var cartCreateMutation = `
    mutation PdpDiscountPreview($cartInput: CartInput!) {
      cartCreate(input: $cartInput) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
          lines(first: 1) {
            nodes {
              quantity
              cost {
                totalAmount {
                  amount
                  currencyCode
                }
              }
              discountAllocations {
                discountedAmount {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  function getCookie(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getConfig(sectionId) {
    var configs = window.SatellaiPdpDiscountPriceConfig || {};
    return configs[sectionId] || {};
  }

  function getSectionRoot(sectionId) {
    var form = document.getElementById('product-form-' + sectionId);
    return (
      (form && form.closest('.collar-product-template')) ||
      document.getElementById('shopify-section-' + sectionId) ||
      document
    );
  }

  function getVariants(sectionId) {
    var state = getState(sectionId);
    if (state.variants) {
      return state.variants;
    }

    var root = getSectionRoot(sectionId);
    var script = root.querySelector('.product-info-wrapper script[type="application/json"]');

    if (!script || !script.textContent) {
      state.variants = [];
      return state.variants;
    }

    try {
      state.variants = JSON.parse(script.textContent);
    } catch (error) {
      state.variants = [];
    }

    return state.variants;
  }

  function getCurrentVariant(sectionId) {
    var store = window.Alpine && window.Alpine.store && window.Alpine.store('variantState' + sectionId);
    if (store && store.currentVariant && store.currentVariant.id) {
      return store.currentVariant;
    }

    var form = document.getElementById('product-form-' + sectionId);
    var input = form && form.querySelector('input[name="id"]');
    var variantId = input && input.value;
    var variants = getVariants(sectionId);

    return variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getCurrentQuantity(sectionId) {
    var productState = window.Alpine && window.Alpine.store && window.Alpine.store('productState');
    var quantity = productState && productState.quantity;

    if (!quantity) {
      var input = document.getElementById('Quantity-' + sectionId);
      quantity = input && input.value;
    }

    quantity = parseInt(quantity, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getState(sectionId) {
    if (!sectionState[sectionId]) {
      sectionState[sectionId] = {
        activeKey: '',
        timer: null,
        variants: null,
      };
    }

    return sectionState[sectionId];
  }

  function getClient(config) {
    var token = config.storefrontAccessToken;
    var shopDomain = config.shopDomain || (window.Shopify && window.Shopify.shop);
    var version = config.apiVersion || apiVersion;

    if (!token || !shopDomain || !window.ShopifyStorefrontAPIClient) {
      return null;
    }

    var cacheKey = [shopDomain, version, token].join('|');
    if (!clientCache[cacheKey]) {
      clientCache[cacheKey] = window.ShopifyStorefrontAPIClient.createStorefrontApiClient({
        storeDomain: shopDomain,
        apiVersion: version,
        publicAccessToken: token,
      });
    }

    return clientCache[cacheKey];
  }

  function toVariantGid(variantId) {
    var id = String(variantId);
    return id.indexOf('gid://') === 0 ? id : 'gid://shopify/ProductVariant/' + id;
  }

  function moneyToCents(money) {
    var amount = money && money.amount;
    var value = Number(amount);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }

  function sumLineDiscounts(line) {
    return (line.discountAllocations || []).reduce(function (total, allocation) {
      return total + moneyToCents(allocation.discountedAmount);
    }, 0);
  }

  function formatMoney(cents, sampleText) {
    var roundedCents = Math.round(Number(cents) || 0);
    var amount = (roundedCents / 100).toFixed(2);
    var showDecimals = Math.abs(roundedCents % 100) !== 0;
    var templateText = String(sampleText || '');
    var numberMatch = templateText.match(/-?\d(?:[\d.,']|\s(?=\d))*/);
    var parts = amount.split('.');

    if (!numberMatch) {
      return showDecimals ? amount : parts[0];
    }

    var sampleNumber = numberMatch[0];
    var lastComma = sampleNumber.lastIndexOf(',');
    var lastDot = sampleNumber.lastIndexOf('.');
    var useCommaDecimal = lastComma > lastDot && lastComma !== -1;
    var thousandSeparator = useCommaDecimal ? '.' : ',';
    var decimalSeparator = useCommaDecimal ? ',' : '.';
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    var formattedNumber = integer + (showDecimals ? decimalSeparator + parts[1] : '');

    return (
      templateText.slice(0, numberMatch.index) +
      formattedNumber +
      templateText.slice(numberMatch.index + sampleNumber.length)
    );
  }

  function isCodeApplicable(cart, discountCode) {
    var targetCode = String(discountCode).toLowerCase();

    return (cart.discountCodes || []).some(function (discount) {
      return String(discount.code).toLowerCase() === targetCode && discount.applicable;
    });
  }

  function buildPreview(payload) {
    var cart = payload.data && payload.data.cartCreate && payload.data.cartCreate.cart;
    var userErrors = payload.data && payload.data.cartCreate && payload.data.cartCreate.userErrors;
    var line = cart && cart.lines && cart.lines.nodes && cart.lines.nodes[0];

    if (payload.errors || (userErrors && userErrors.length) || !cart || !line) {
      return null;
    }

    var quantity = payload.quantity;
    var currentUnitCents = Number(payload.variant.price) || 0;
    var compareAtUnitCents = Number(payload.variant.compare_at_price) || 0;
    var originalUnitCents = compareAtUnitCents > currentUnitCents ? compareAtUnitCents : currentUnitCents;
    var currentTotalCents = currentUnitCents * quantity;
    var originalTotalCents = originalUnitCents * quantity;
    var discountedTotalCents = moneyToCents(line.cost && line.cost.totalAmount);
    var discountTotalCents = sumLineDiscounts(line);
    var hasDiscount =
      isCodeApplicable(cart, payload.discountCode) &&
      discountTotalCents > 0 &&
      discountedTotalCents > 0 &&
      discountedTotalCents < currentTotalCents;

    if (!hasDiscount) {
      return null;
    }

    return {
      sectionId: payload.sectionId,
      key: payload.key,
      quantity: quantity,
      originalUnitCents: originalUnitCents,
      originalTotalCents: originalTotalCents,
      discountedUnitCents: Math.round(discountedTotalCents / quantity),
      discountedTotalCents: discountedTotalCents,
      saveUnitCents: Math.max(0, originalUnitCents - Math.round(discountedTotalCents / quantity)),
      saveTotalCents: Math.max(0, originalTotalCents - discountedTotalCents),
    };
  }

  function fetchPreview(sectionId, variant, quantity, discountCode, key) {
    var config = getConfig(sectionId);
    var client = getClient(config);

    if (!client) {
      return Promise.resolve(null);
    }

    if (responseCache[key]) {
      return Promise.resolve(responseCache[key]);
    }

    return client
      .request(cartCreateMutation, {
        variables: {
          cartInput: {
            lines: [
              {
                merchandiseId: toVariantGid(variant.id),
                quantity: quantity,
              },
            ],
            discountCodes: [discountCode],
          },
        },
      })
      .then(function (result) {
        var preview = buildPreview({
          data: result.data,
          errors: result.errors,
          sectionId: sectionId,
          variant: variant,
          quantity: quantity,
          discountCode: discountCode,
          key: key,
        });

        responseCache[key] = preview;
        return preview;
      })
      .catch(function () {
        return null;
      });
  }

  function setDisplay(element, value) {
    if (element) {
      element.style.display = value;
    }
  }

  function updateText(element, cents, sampleText) {
    if (element) {
      element.textContent = formatMoney(cents, sampleText || element.textContent);
    }
  }

  function updateTitlePrice(sectionId, preview) {
    var root = document.getElementById('collar-title-price-' + sectionId);
    if (!root) {
      return;
    }

    var currentPrice = root.querySelector('[x-ref="currentPrice"]');
    var regularPrice = root.querySelector('[x-ref="regularPrice"]');
    var comparePrice = root.querySelector('[x-ref="comparePrice"]');
    var saveAmount = root.querySelector('[x-ref="saveAmount"]');
    var salePriceContainer = root.querySelector('[x-ref="salePriceContainer"]');
    var regularPriceContainer = root.querySelector('[x-ref="regularPriceContainer"]');
    var comparePriceWrapper =
      root.querySelector('[x-ref="comparePriceWrapper"]') ||
      (comparePrice && comparePrice.closest('.compare-price-wrapper'));
    var saveTag = root.querySelector('[x-ref="saveTag"]');
    var sampleText = (currentPrice && currentPrice.textContent) || (regularPrice && regularPrice.textContent);

    setDisplay(salePriceContainer, '');
    setDisplay(regularPriceContainer, 'none');
    setDisplay(comparePriceWrapper, '');
    setDisplay(saveTag, '');

    updateText(currentPrice, preview.discountedUnitCents, sampleText);
    updateText(regularPrice, preview.discountedUnitCents, sampleText);
    updateText(comparePrice, preview.originalUnitCents, sampleText);
    updateText(saveAmount, preview.saveUnitCents, sampleText);
  }

  function updateFooterPrice(sectionId, preview) {
    var root = getSectionRoot(sectionId);
    var priceArea = root.querySelector('.collar-cart-footer .price-area');

    if (!priceArea) {
      return;
    }

    var currentPrice = priceArea.querySelector('[x-ref="currentPrice"]');
    var comparePrice = priceArea.querySelector('[x-ref="comparePrice"]');
    var saveAmount = priceArea.querySelector('[x-ref="saveAmount"]');
    var saveTag = priceArea.querySelector('[x-ref="saveTag"]');
    var sampleText = currentPrice && currentPrice.textContent;

    setDisplay(saveTag, '');
    if (comparePrice && comparePrice.parentElement) {
      setDisplay(comparePrice.parentElement, '');
    }

    updateText(currentPrice, preview.discountedTotalCents, sampleText);
    updateText(comparePrice, preview.originalTotalCents, sampleText);
    updateText(saveAmount, preview.saveTotalCents, sampleText);
  }

  function applyPreview(sectionId, preview) {
    var state = getState(sectionId);

    if (!preview || state.activeKey !== preview.key) {
      return;
    }

    updateTitlePrice(sectionId, preview);
    updateFooterPrice(sectionId, preview);
  }

  function refresh(sectionId) {
    var discountCode = getCookie('discount_code').trim();
    var variant = getCurrentVariant(sectionId);
    var quantity = getCurrentQuantity(sectionId);
    var state = getState(sectionId);

    if (!discountCode || !variant || !variant.id || !variant.price) {
      state.activeKey = '';
      return;
    }

    var key = [sectionId, discountCode, variant.id, quantity].join('|');
    state.activeKey = key;

    fetchPreview(sectionId, variant, quantity, discountCode, key).then(function (preview) {
      applyPreview(sectionId, preview);
    });
  }

  function queueRefresh(sectionId) {
    if (!sectionId) {
      return;
    }

    var id = String(sectionId);
    var state = getState(id);

    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () {
      refresh(id);
    }, 0);
  }

  function queueConfiguredSections() {
    var configs = window.SatellaiPdpDiscountPriceConfig || {};
    Object.keys(configs).forEach(queueRefresh);
  }

  window.SatellaiPdpDiscountPrice = {
    queueRefresh: queueRefresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueConfiguredSections);
  } else {
    queueConfiguredSections();
  }
})();

(function () {
  var scriptName = 'pdp-discount-price.js';

  window.Eurus = window.Eurus || { loadedScript: [] };
  window.Eurus.loadedScript = window.Eurus.loadedScript || [];

  if (window.Eurus.loadedScript.includes(scriptName)) {
    return;
  }

  window.Eurus.loadedScript.push(scriptName);

  var apiVersion = '2025-07';
  var sectionState = {};
  var responseCache = {};
  var clientCache = {};

  var cartCreateMutation = `
    mutation PdpDiscountPreview($cartInput: CartInput!) {
      cartCreate(input: $cartInput) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
          lines(first: 1) {
            nodes {
              quantity
              cost {
                totalAmount {
                  amount
                  currencyCode
                }
              }
              discountAllocations {
                discountedAmount {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  function getCookie(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getConfig(sectionId) {
    var configs = window.SatellaiPdpDiscountPriceConfig || {};
    return configs[sectionId] || {};
  }

  function getSectionRoot(sectionId) {
    var form = document.getElementById('product-form-' + sectionId);
    return (
      (form && form.closest('.collar-product-template')) ||
      document.getElementById('shopify-section-' + sectionId) ||
      document
    );
  }

  function getVariants(sectionId) {
    var state = getState(sectionId);
    if (state.variants) {
      return state.variants;
    }

    var root = getSectionRoot(sectionId);
    var script = root.querySelector('.product-info-wrapper script[type="application/json"]');

    if (!script || !script.textContent) {
      state.variants = [];
      return state.variants;
    }

    try {
      state.variants = JSON.parse(script.textContent);
    } catch (error) {
      state.variants = [];
    }

    return state.variants;
  }

  function getCurrentVariant(sectionId) {
    var store = window.Alpine && window.Alpine.store && window.Alpine.store('variantState' + sectionId);
    if (store && store.currentVariant && store.currentVariant.id) {
      return store.currentVariant;
    }

    var form = document.getElementById('product-form-' + sectionId);
    var input = form && form.querySelector('input[name="id"]');
    var variantId = input && input.value;
    var variants = getVariants(sectionId);

    return variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getCurrentQuantity(sectionId) {
    var productState = window.Alpine && window.Alpine.store && window.Alpine.store('productState');
    var quantity = productState && productState.quantity;

    if (!quantity) {
      var input = document.getElementById('Quantity-' + sectionId);
      quantity = input && input.value;
    }

    quantity = parseInt(quantity, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getState(sectionId) {
    if (!sectionState[sectionId]) {
      sectionState[sectionId] = {
        activeKey: '',
        timer: null,
        variants: null,
      };
    }

    return sectionState[sectionId];
  }

  function getClient(config) {
    var token = config.storefrontAccessToken;
    var shopDomain = config.shopDomain || (window.Shopify && window.Shopify.shop);
    var version = config.apiVersion || apiVersion;

    if (!token || !shopDomain || !window.ShopifyStorefrontAPIClient) {
      return null;
    }

    var cacheKey = [shopDomain, version, token].join('|');
    if (!clientCache[cacheKey]) {
      clientCache[cacheKey] = window.ShopifyStorefrontAPIClient.createStorefrontApiClient({
        storeDomain: shopDomain,
        apiVersion: version,
        publicAccessToken: token,
      });
    }

    return clientCache[cacheKey];
  }

  function toVariantGid(variantId) {
    var id = String(variantId);
    return id.indexOf('gid://') === 0 ? id : 'gid://shopify/ProductVariant/' + id;
  }

  function moneyToCents(money) {
    var amount = money && money.amount;
    var value = Number(amount);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }

  function sumLineDiscounts(line) {
    return (line.discountAllocations || []).reduce(function (total, allocation) {
      return total + moneyToCents(allocation.discountedAmount);
    }, 0);
  }

  function formatMoney(cents, sampleText) {
    var roundedCents = Math.round(Number(cents) || 0);
    var amount = (roundedCents / 100).toFixed(2);
    var showDecimals = Math.abs(roundedCents % 100) !== 0;
    var templateText = String(sampleText || '');
    var numberMatch = templateText.match(/-?\d(?:[\d.,']|\s(?=\d))*/);
    var parts = amount.split('.');

    if (!numberMatch) {
      return showDecimals ? amount : parts[0];
    }

    var sampleNumber = numberMatch[0];
    var lastComma = sampleNumber.lastIndexOf(',');
    var lastDot = sampleNumber.lastIndexOf('.');
    var useCommaDecimal = lastComma > lastDot && lastComma !== -1;
    var thousandSeparator = useCommaDecimal ? '.' : ',';
    var decimalSeparator = useCommaDecimal ? ',' : '.';
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    var formattedNumber = integer + (showDecimals ? decimalSeparator + parts[1] : '');

    return (
      templateText.slice(0, numberMatch.index) +
      formattedNumber +
      templateText.slice(numberMatch.index + sampleNumber.length)
    );
  }

  function isCodeApplicable(cart, discountCode) {
    var targetCode = String(discountCode).toLowerCase();

    return (cart.discountCodes || []).some(function (discount) {
      return String(discount.code).toLowerCase() === targetCode && discount.applicable;
    });
  }

  function buildPreview(payload) {
    var cart = payload.data && payload.data.cartCreate && payload.data.cartCreate.cart;
    var userErrors = payload.data && payload.data.cartCreate && payload.data.cartCreate.userErrors;
    var line = cart && cart.lines && cart.lines.nodes && cart.lines.nodes[0];

    if (payload.errors || (userErrors && userErrors.length) || !cart || !line) {
      return null;
    }

    var quantity = payload.quantity;
    var originalUnitCents = Number(payload.variant.price) || 0;
    var originalTotalCents = originalUnitCents * quantity;
    var discountedTotalCents = moneyToCents(line.cost && line.cost.totalAmount);
    var discountTotalCents = sumLineDiscounts(line);
    var hasDiscount =
      isCodeApplicable(cart, payload.discountCode) &&
      discountTotalCents > 0 &&
      discountedTotalCents > 0 &&
      discountedTotalCents < originalTotalCents;

    if (!hasDiscount) {
      return null;
    }

    return {
      sectionId: payload.sectionId,
      key: payload.key,
      quantity: quantity,
      originalUnitCents: originalUnitCents,
      originalTotalCents: originalTotalCents,
      discountedUnitCents: Math.round(discountedTotalCents / quantity),
      discountedTotalCents: discountedTotalCents,
      saveUnitCents: Math.max(0, originalUnitCents - Math.round(discountedTotalCents / quantity)),
      saveTotalCents: Math.max(0, originalTotalCents - discountedTotalCents),
    };
  }

  function fetchPreview(sectionId, variant, quantity, discountCode, key) {
    var config = getConfig(sectionId);
    var client = getClient(config);

    if (!client) {
      return Promise.resolve(null);
    }

    if (responseCache[key]) {
      return Promise.resolve(responseCache[key]);
    }

    return client
      .request(cartCreateMutation, {
        variables: {
          cartInput: {
            lines: [
              {
                merchandiseId: toVariantGid(variant.id),
                quantity: quantity,
              },
            ],
            discountCodes: [discountCode],
          },
        },
      })
      .then(function (result) {
        var preview = buildPreview({
          data: result.data,
          errors: result.errors,
          sectionId: sectionId,
          variant: variant,
          quantity: quantity,
          discountCode: discountCode,
          key: key,
        });

        responseCache[key] = preview;
        return preview;
      })
      .catch(function () {
        return null;
      });
  }

  function setDisplay(element, value) {
    if (element) {
      element.style.display = value;
    }
  }

  function updateText(element, cents, sampleText) {
    if (element) {
      element.textContent = formatMoney(cents, sampleText || element.textContent);
    }
  }

  function updateTitlePrice(sectionId, preview) {
    var root = document.getElementById('collar-title-price-' + sectionId);
    if (!root) {
      return;
    }

    var currentPrice = root.querySelector('[x-ref="currentPrice"]');
    var regularPrice = root.querySelector('[x-ref="regularPrice"]');
    var comparePrice = root.querySelector('[x-ref="comparePrice"]');
    var saveAmount = root.querySelector('[x-ref="saveAmount"]');
    var salePriceContainer = root.querySelector('[x-ref="salePriceContainer"]');
    var regularPriceContainer = root.querySelector('[x-ref="regularPriceContainer"]');
    var comparePriceWrapper =
      root.querySelector('[x-ref="comparePriceWrapper"]') ||
      (comparePrice && comparePrice.closest('.compare-price-wrapper'));
    var saveTag = root.querySelector('[x-ref="saveTag"]');
    var sampleText = (currentPrice && currentPrice.textContent) || (regularPrice && regularPrice.textContent);

    setDisplay(salePriceContainer, '');
    setDisplay(regularPriceContainer, 'none');
    setDisplay(comparePriceWrapper, '');
    setDisplay(saveTag, '');

    updateText(currentPrice, preview.discountedUnitCents, sampleText);
    updateText(regularPrice, preview.discountedUnitCents, sampleText);
    updateText(comparePrice, preview.originalUnitCents, sampleText);
    updateText(saveAmount, preview.saveUnitCents, sampleText);
  }

  function updateFooterPrice(sectionId, preview) {
    var root = getSectionRoot(sectionId);
    var priceArea = root.querySelector('.collar-cart-footer .price-area');

    if (!priceArea) {
      return;
    }

    var currentPrice = priceArea.querySelector('[x-ref="currentPrice"]');
    var comparePrice = priceArea.querySelector('[x-ref="comparePrice"]');
    var saveAmount = priceArea.querySelector('[x-ref="saveAmount"]');
    var saveTag = priceArea.querySelector('[x-ref="saveTag"]');
    var sampleText = currentPrice && currentPrice.textContent;

    setDisplay(saveTag, '');
    if (comparePrice && comparePrice.parentElement) {
      setDisplay(comparePrice.parentElement, '');
    }

    updateText(currentPrice, preview.discountedTotalCents, sampleText);
    updateText(comparePrice, preview.originalTotalCents, sampleText);
    updateText(saveAmount, preview.saveTotalCents, sampleText);
  }

  function applyPreview(sectionId, preview) {
    var state = getState(sectionId);

    if (!preview || state.activeKey !== preview.key) {
      return;
    }

    updateTitlePrice(sectionId, preview);
    updateFooterPrice(sectionId, preview);
  }

  function refresh(sectionId) {
    var discountCode = getCookie('discount_code').trim();
    var variant = getCurrentVariant(sectionId);
    var quantity = getCurrentQuantity(sectionId);
    var state = getState(sectionId);

    if (!discountCode || !variant || !variant.id || !variant.price) {
      state.activeKey = '';
      return;
    }

    var key = [sectionId, discountCode, variant.id, quantity].join('|');
    state.activeKey = key;

    fetchPreview(sectionId, variant, quantity, discountCode, key).then(function (preview) {
      applyPreview(sectionId, preview);
    });
  }

  function queueRefresh(sectionId) {
    if (!sectionId) {
      return;
    }

    var id = String(sectionId);
    var state = getState(id);

    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () {
      refresh(id);
    }, 0);
  }

  function queueConfiguredSections() {
    var configs = window.SatellaiPdpDiscountPriceConfig || {};
    Object.keys(configs).forEach(queueRefresh);
  }

  window.SatellaiPdpDiscountPrice = {
    queueRefresh: queueRefresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueConfiguredSections);
  } else {
    queueConfiguredSections();
  }
})();
